type CategoryNode = { name?: string | null; parent?: CategoryNode | null };

/**
 * Joins a category with its parents into `Root / Child / Leaf`, as far up as the parents were fetched. A category
 * without a name has no path.
 */
export const formatCategoryPath = (category: CategoryNode | null | undefined): string | undefined => {
	if (!category?.name) return undefined;

	const parentPath = formatCategoryPath(category.parent);

	return parentPath ? `${parentPath} / ${category.name}` : category.name;
};
